import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../infra/hooks";
import { dashboardService } from "../../../api/services/dashboardService";
import { upcomingBirthdayService } from "../../../api/services/upcomingBirthdayService";
import { clockInService } from "../../../api/services/clockInService";
import { canClockIn } from "../../../infra/aggregates/clockInSlice";
import { seEmpStatus } from "../../../infra/aggregates/empStatusSlice";
import { commonServices } from "../../../api/services/commonServices";
import LoaderSlice, { setLoading } from "../../../infra/aggregates/LoaderSlice";

interface InnerBar {
  profile_pic: any;
  name: string;
  designation: string;
  award: any;
}

interface PropsValues {
  setInnerBarData: (data: InnerBar) => void;
  setBirthdayData: (data: any) => void;
}

function DTOInnerBarDashboard({
  setInnerBarData,
  setBirthdayData,
}: PropsValues) {
  const selector = useAppSelector((state) => state);

  const dispatch = useAppDispatch();

  let initializeData: InnerBar = {
    name: "",
    profile_pic: "",
    designation: "",
    award: "",
  };

  useEffect(() => {
    if (selector.authSlice.user_id) {
      initializeData = {
        name:
          selector.personalInfoSlice.firstName +
          " " +
          selector.personalInfoSlice.lastName,
        profile_pic: selector?.profilePicSlice?.profilePic,
        designation: selector.authSlice.designaion,
        award: selector.userAwardsSlice.awards,
      };
      setInnerBarData(initializeData);
    }
  }, [
    selector?.personalInfoSlice,
    selector?.profilePicSlice,
    selector.authSlice,
    selector.userAwardsSlice.awards,
  ]);

  async function getBirthayList(empId: number) {
    const response = await upcomingBirthdayService.birthdayService(empId);
    if (response.response == "success") {
      let birthdayList: any = [];
      response.data.upcomming_events.map((list: any) => {
        if (list.notification_type == "Birthdays") {
          birthdayList = list.notification_data;

          return setBirthdayData(birthdayList);
        }
      });
    }
  }

  async function checkInStatus(empId: number) {
    await clockInService
      .can_checkin(empId)
      .then((response: any) => {
        if (response?.data) {
          dispatch(
            canClockIn({
              can_checkin: response?.data?.can_checkin,
              last_checkIn_time: response?.data?.last_checkIn_time,
            })
          );
        } else {
          return;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (selector.authSlice) {
      initializeData = {
        name: selector.personalInfoSlice.firstName
          ? selector.personalInfoSlice.firstName +
            " " +
            selector.personalInfoSlice.lastName
          : selector.authSlice?.name,
        profile_pic: selector?.profilePicSlice?.profilePic,
        designation: selector.authSlice.designaion,
        award: selector.userAwardsSlice.awards,
      };
      getBirthayList(selector.authSlice.emp_id);
      setInnerBarData(initializeData);
      checkInStatus(selector.authSlice.emp_id);
    }
  }, []);

  return <></>;
}
export default DTOInnerBarDashboard;
